import React from "react";
export class Copyright extends React.Component {
  render() {
    return (
      <div className="copyright">
        <a
          href="//www.stuffstudio.pl"
          target="_blank"
          rel="noopener noreferrer"
        >
          web by stuffstudio
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Copyright.js